/**
 * Format date from Firestore timestamp
 * @param {Object} timestamp - Firestore timestamp with seconds property
 * @returns {string} Formatted date string (MM/DD/YYYY)
 */
export const formatDate = (timestamp) => {
  if (!timestamp?.seconds) return "-";
  const date = new Date(timestamp.seconds * 1000);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

/**
 * Format date and time from Firestore timestamp
 * @param {Object} timestamp - Firestore timestamp with seconds property
 * @returns {string} Formatted date and time string
 */
export const formatDateTime = (timestamp) => {
  if (!timestamp?.seconds) return "-";
  const date = new Date(timestamp.seconds * 1000);
  const formattedDate = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
  return `${formattedDate} ${formattedTime}`;
};

/**
 * Get image URL by country code from country flags data
 * @param {string} countryName - Country name
 * @param {Array} countryFlags - Array of country flags data
 * @returns {string} Image URL or empty string
 */
export const getImageUrlByCountryCode = (countryName, countryFlags) => {
  if (!countryName || !countryFlags) return "";
  const country = countryFlags.find(
    (country) => country?.name === countryName
  );
  return country ? country.image : "";
};

